<template>
  <div class="login">
    <div v-loading="loading">
      <div class="login-title">ログイン</div>
      <!-- <div class="login-register">
        <span>初めにご利用の方は</span>
        <router-link to="/register">新規登録</router-link>
      </div> -->
      <div class="login-docs">
        「<a href = "/terms.html" target="_blank">利用規約</a>」
        「<a href = "/privacy.html" target="_blank">個人情報保護方針について</a>」
        <span>に同意の上ご利用ください。</span>
      </div>
      <el-form ref="loginForm" :model="form" class="app-form" :rules="rules">
        <el-form-item label="" prop="toId" v-if="!isToVisible">
          <el-select
            v-model="form.toId"
            placeholder=""
            filterable
          >
            <el-option
              v-for="item in afterLoadingToList"
              :key="item.toId"
              :label="item.toName"
              :value="item.toId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部屋番号" prop="roomId">
          <el-input v-model="form.roomId" maxlength="8" :disabled="form.roomIdDisabled" placeholder=""></el-input>
        </el-form-item>
        <!-- <el-form-item label="ログインID" prop="username">
          <el-input v-model="form.username" autocomplete="off" maxlength="50"
            placeholder="ログインID"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="パスワード" prop="password" style="margin-bottom: 35px">
          <el-input type="password" v-model="form.password" autocomplete="off" maxlength="8"
            placeholder="半角英数字大文字小文字含む8桁"
          ></el-input>
        </el-form-item>
        <div class="button-container">
          <el-form-item class="form-item-left">
            <el-button native-type="button" type="danger" @click="goOwner()" plain>新規登録</el-button>
          </el-form-item>
          <el-form-item class="form-item-right">
            <el-button class="studypack-button-primary" type="primary" @click="onSubmit()">ログイン</el-button>
          </el-form-item>
        </div>
        <br>
        <router-link to="/forgot">パスワードをお忘れですか？</router-link>
        <br>
        <br>
      </el-form>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import tools from '@/utils/tools';
import Cookies from 'js-cookie';
// import { Notification } from 'element-ui';

const { checkUserName } = tools;

export default {
  name: 'Login',
  inject: ['manshonId', 'toList'],
  data() {
    return {
      loading: true,
      isToVisible: false,
      form: {
        username: '',
        password: '',
        toId: '',
        roomId: '',
        roomIdDisabled: false
      },
      rules: {
        toId: [
          { required: true, message: '', trigger: 'change' },
        ],
        // roomId: [
        //   { required: true, message: '必須です。', trigger: 'blur' },
        //   { pattern: /^[a-zA-Z0-9]{1,8}$/, message: '半角英数字8桁以内で入力してください。', trigger: 'blur' }
        // ],
        password: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' }
        ],
      },
    };
  },
  computed: {
    afterLoadingToList() {
      const list = this.toList();
      // データ返却後のローディングを閉じる
      if (Array.isArray(list)) {
        this.loading = list.length === 0;
        if (list.length === 1 && list[0].toId === '00') {
          this.form.toId = list[0].toId;
          this.isToVisible = true;
        } 
      }
      return list;
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 60000);
  },
  created() {
    const urlRoomId = this.$route.query.roomId 
      || new URLSearchParams(window.location.search).get('roomId');
    if (urlRoomId) {
      this.form.roomIdDisabled = true; // フォームの部屋番号を無効化
      this.form.roomId = urlRoomId;
    } else {
      this.form.roomIdDisabled = false; // フォームの部屋番号を有効化
      this.form.roomId = '';
    }
  },
  methods: {
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          request('login', {
            manshonId: this.manshonId(),
            toId: this.form.toId,
            roomId: this.form.roomId,
            password: this.form.password,
          }).then((res) => {
            const { redirect } = this.$route.query;
            const { expireTime, token } = res;
            Cookies.set('token', token, { expires: expireTime });
            Cookies.set('userNameKanji', this.form.roomId);
            request('toCode', {
            }).then((resCode) => {
              sessionStorage.setItem('codeNameList', JSON.stringify(resCode));
            });
            this.goBoard();
          });
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
    goBoard() {
      this.$router.push({
        path: "/board",
        query: { manshonId: this.manshonId() }
      }).catch(() => {});
    },
    goOwner() {
      this.$router.push({
        path: '/ownerRigest',
        query: { 
          manshonId: this.manshonId(),
          ...(this.form.roomId ? { roomId: this.form.roomId } : {})
        }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less">
.login {
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  margin: 40px auto;
  max-width: 600px;

  .login-title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 24px;
  }

  .login-register {
    text-align: center;
    font-size: 20px;
    margin-bottom: 24px;
  }

  .login-docs {
    text-align: center;
    font-size: 16px;
    margin-bottom: 24px;
  }

  .notice {
    width: 100%;
    border: 2px solid red;
    padding: 8px 12px;
    font-size: 15px;
    color: red;
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.5em;
  }

  /* 调整按钮布局 */
  .button-container {
    display: flex;
    justify-content: space-between; /* 使按钮在两端 */
    margin-top: 20px; /* 给按钮区域加一点顶部间距 */
  }

  .form-item-left,
  .form-item-right {
    margin: 0; /* 清除默认的 margin */
  }

  .form-item-left {
    margin-right: 10px; /* 左侧按钮和右侧按钮之间的间隔 */
  }

  .form-item-right {
    margin-left: 10px; /* 右侧按钮和左侧按钮之间的间隔 */
  }
}
</style>
